/**
 * @Description 动态组件是否必填
 */

import {
  useMemo
} from 'react';
import { AlwaysRequiredChanceIndentifications } from '../customize';

/**
 * TODO(2026-1029迭代/机会点表单字段必填/可见/可写，文档：https://confluence.lanhanba.com/pages/viewpage.action?pageId=172107370)：
 * Locxx 提交时 access=1/3 不参与必填；access=null 表示模板未配置发起节点表单权限，按字段自身 required 判断。
 */

export function useAccessIsRequired({
  propertyItem,
  isChancepoint = true, // 是否机会点表单，加盟商时false
  writableOnly = false, // Locxx 拓店任务模板提交时传 true
  supportDirectApproval = 2,
}) {
  return useMemo(() => {
    // Locxx 下仅 access=1/3 不参与；access=null 在直接审批时保持不参与必填，否则按字段自身 required 判断。
    if (writableOnly) {
      const access = propertyItem.access;
      if (access === 1 || access === 3) return false;
      if (supportDirectApproval === 1 && access !== 2) return false;
    }
    // 机会点时指定特定identification必填字段
    const isIdentiRequired = isChancepoint && Array.isArray(AlwaysRequiredChanceIndentifications) && AlwaysRequiredChanceIndentifications?.includes(propertyItem?.identification);

    return isIdentiRequired || !!propertyItem.required;
  }, [propertyItem, isChancepoint, writableOnly, supportDirectApproval]);
}
